import { memo, useState } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { mdlRoomType } from "../../../models/domain/RoomType";
import { HotelSelect } from "../../common/HotelSelect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";

export type CopyRoomAndTypeToOtherHotelsProps = {
    selectedHotel?: string;
    selectedRoomAndTypeList?: string[];
    onSelected?: Function;
    fnCopy?: Function;
    fnModalClose?: Function;
    otherHotels?: string[];
}

export const CopyRoomAndTypeToOtherHotels = memo(function CopyRoomAndTypeToOtherHotels(props: CopyRoomAndTypeToOtherHotelsProps) {
    const { t } = useTranslation();
    const [selectedData, setSelectedData] = useState<string | string[]>();
    const addNew = () => {
        props.fnCopy && props.fnCopy(selectedData);
    }
    const closeModal = () => {
        props.fnModalClose && props.fnModalClose();
    }

    const onSelected = (value: string | string[]) => {
        setSelectedData(value);
        props.onSelected && props.onSelected(value);
    }
    return (
        <>
            <div className="row">
                {
                    !props.selectedRoomAndTypeList
                    &&
                    <div className="col-sm-12">
                        <div className="alert alert-warning alert-icon">
                            <FontAwesomeIcon icon={faWarning} />
                            <span className="ps-4">{t('definitions.hotels.mustChooseItems')}</span>
                        </div>
                    </div>
                }
                {
                    props.selectedRoomAndTypeList
                    &&
                    <>
                        <div className="col-sm-12 mb-4 full-width-ant-select">
                            <HotelSelect mode="multiple" onChange={onSelected} excludedValue={props.selectedHotel} />
                        </div>
                        <div className="col-md-12 mt-4 text-end ">
                            <Button className="btn btn-secondary btn-dim me-2 " onClick={addNew} disabled={selectedData == undefined}>{t("common.copy")}</Button>
                            <Button className="btn btn-danger btn-dim me-2 " onClick={closeModal}>{t("common.close")}</Button>
                        </div>
                    </>
                }
            </div>
        </>
    )
})